import mixins from 'vue-typed-mixins';

import { Eフェーズ種別 } from '@/openapi/enum';

import { PrintConfig, PrintDialogStyle, 償却Option } from '@/components/データ/print/データPrint';
import CデータPrint from '@/components/データ/print/データPrint.vue';

import RoutesMixin from '@/entries/user/mixins/RoutesMixin';
import 事業所Mixin from '@/entries/user/mixins/事業所Mixin';
import 計画書Mixin from '@/entries/user/mixins/計画書Mixin';

import { 帳票Type } from '@/classes/service/Abstract計画PlbscfService';
import 分析PlbscfService from '@/classes/service/分析/分析PlbscfService';
import 実態BSService from '@/classes/service/分析/実態BSService';
import 償却Service from '@/classes/service/分析計画/償却Service';
import 役員借入Service from '@/classes/service/分析計画/役員借入Service';
import 金融機関借入Service from '@/classes/service/分析計画/金融機関借入Service';
import 実態純資産Service from '@/classes/service/計画/実態純資産Service';
import 納税予測Service from '@/classes/service/計画/納税予測Service';
import 計画PlbscfService from '@/classes/service/計画/計画PlbscfService';
import 資金繰りService from '@/classes/service/計画/資金繰りService';
import 返済明細Service from '@/classes/service/計画/返済明細Service';
import 返済計画Service from '@/classes/service/計画/返済計画Service';
import { PlbscfType } from '@/master/Plbscf';

export default mixins(RoutesMixin, 事業所Mixin, 計画書Mixin).extend({
  name: 'P計画',

  components: {
    CデータPrint,
  },

  data(): {
    eフェーズ種別: Eフェーズ種別;
    printDialogStyle: PrintDialogStyle;
    printConfigs: PrintConfig[];
  } {
    const v計画PlbscfService = new 計画PlbscfService(Eフェーズ種別.計画フェーズ);
    v計画PlbscfService.setIs帳票 = true;
    const v償却Service = new 償却Service(Eフェーズ種別.計画フェーズ);
    const v返済計画Service = new 返済計画Service(Eフェーズ種別.計画フェーズ);
    const v返済明細Service = new 返済明細Service(Eフェーズ種別.計画フェーズ);
    const v金融機関借入Service = new 金融機関借入Service(Eフェーズ種別.計画フェーズ);
    const v役員借入Service = new 役員借入Service(Eフェーズ種別.計画フェーズ);
    const v納税予測Service = new 納税予測Service(Eフェーズ種別.計画フェーズ);
    const v資金繰りService = new 資金繰りService(Eフェーズ種別.計画フェーズ);
    const v実態純資産Service = new 実態純資産Service(Eフェーズ種別.計画フェーズ);

    const v実態BSService = new 実態BSService(Eフェーズ種別.分析フェーズ);
    const v分析PlbscfService = new 分析PlbscfService(Eフェーズ種別.分析フェーズ);

    const opt設備投資: 償却Option = { functionType: '設備投資' };
    const opt償却予測額: 償却Option = { functionType: '償却予測額' };
    return {
      eフェーズ種別: Eフェーズ種別.計画フェーズ,
      printDialogStyle: {
        width: '800px',
        top: '0vh',
        tableClass: 'keikaku',
      },
      printConfigs: [
        {
          name: '貸借対照表計画',
          service: v計画PlbscfService,
          with勘定科目: true,
          with部門: true,
          option: {
            分析PlbscfService: v分析PlbscfService,
            償却Service: v償却Service,
            返済明細Service: v返済明細Service,
            plbscfType: PlbscfType.貸借対照表,
            帳票Type: 帳票Type.標準,
          },
        },
        {
          name: '補助科目別計画',
          service: v計画PlbscfService,
          with勘定科目: true,
          with部門: true,
          option: {
            分析PlbscfService: v分析PlbscfService,
            償却Service: v償却Service,
            返済明細Service: v返済明細Service,
            plbscfType: PlbscfType.貸借対照表,
            帳票Type: 帳票Type.補助科目別,
          },
        },
        {
          name: '損益計算書計画',
          service: v計画PlbscfService,
          with勘定科目: true,
          with部門: true,
          option: {
            分析PlbscfService: v分析PlbscfService,
            償却Service: v償却Service,
            返済明細Service: v返済明細Service,
            plbscfType: PlbscfType.損益計算書,
            帳票Type: 帳票Type.標準,
          },
        },
        {
          name: '部門別計画',
          service: v計画PlbscfService,
          with勘定科目: true,
          with部門: true,
          format: '全部門',
          option: {
            分析PlbscfService: v分析PlbscfService,
            償却Service: v償却Service,
            返済明細Service: v返済明細Service,
            plbscfType: PlbscfType.損益計算書,
            帳票Type: 帳票Type.部門別,
          },
        },
        {
          name: '科目別計画',
          service: v計画PlbscfService,
          with勘定科目: true,
          with部門: true,
          format: '全部門',
          option: {
            分析PlbscfService: v分析PlbscfService,
            償却Service: v償却Service,
            返済明細Service: v返済明細Service,
            plbscfType: PlbscfType.損益計算書,
            帳票Type: 帳票Type.科目別,
          },
        },
        {
          name: 'キャッシュフロー計算書計画',
          service: v計画PlbscfService,
          with勘定科目: true,
          with部門: true,
          option: {
            分析PlbscfService: v分析PlbscfService,
            償却Service: v償却Service,
            返済明細Service: v返済明細Service,
            plbscfType: PlbscfType.CF計算書,
            帳票Type: 帳票Type.標準,
          },
        },
        {
          name: '設備投資計画',
          service: v償却Service,
          with勘定科目: true,
          option: opt設備投資,
        },
        {
          name: '償却予測額確認表',
          service: v償却Service,
          with勘定科目: true,
          with部門: true,
          option: opt償却予測額,
        },
        {
          name: '償却予測額確認表（簡易表示）',
          service: v償却Service,
          with勘定科目: true,
          with部門: true,
          option: {
            ...opt償却予測額,
            isSimple: true,
          },
        },
        {
          name: '借入返済計画',
          service: v返済計画Service,
          with勘定科目: true,
          with部門: true,
          option: {
            計画PlbscfService: v計画PlbscfService,
            金融機関借入Service: v金融機関借入Service,
          },
        },
        {
          name: '借入返済明細',
          service: v返済明細Service,
          option: {
            金融機関借入Service: v金融機関借入Service,
            役員借入Service: v役員借入Service,
          },
        },
        {
          name: '金融機関借入一覧表',
          service: v金融機関借入Service,
        },
        {
          name: '役員借入一覧表',
          service: v役員借入Service,
        },
        {
          name: '納税額試算表',
          service: v納税予測Service,
          with勘定科目: true,
          with部門: true,
          option: {
            計画PlbscfService: v計画PlbscfService,
            償却Service: v償却Service,
          },
        },
        {
          name: '資金繰り予定表',
          service: v資金繰りService,
          with勘定科目: true,
          with部門: true,
          option: {
            計画PlbscfService: v計画PlbscfService,
            返済明細Service: v返済明細Service,
          },
        },
        {
          name: '変動損益計算書計画',
          service: v計画PlbscfService,
          with勘定科目: true,
          with部門: true,
          option: {
            分析PlbscfService: v分析PlbscfService,
            償却Service: v償却Service,
            返済明細Service: v返済明細Service,
            plbscfType: PlbscfType.変動損益,
            帳票Type: 帳票Type.標準,
          },
        },
        {
          name: '運転資金・回転期間計画',
          service: v計画PlbscfService,
          with勘定科目: true,
          with部門: true,
          option: {
            分析PlbscfService: v分析PlbscfService,
            償却Service: v償却Service,
            返済明細Service: v返済明細Service,
            plbscfType: PlbscfType.運転資金,
            帳票Type: 帳票Type.標準,
          },
        },
        {
          name: 'FCF・債務償還年数計画',
          service: v計画PlbscfService,
          with勘定科目: true,
          with部門: true,
          option: {
            分析PlbscfService: v分析PlbscfService,
            償却Service: v償却Service,
            返済明細Service: v返済明細Service,
            plbscfType: PlbscfType.FCF,
            帳票Type: 帳票Type.標準,
          },
        },
        {
          name: '実態純資産推移表',
          service: v実態純資産Service,
          with勘定科目: true,
          with部門: true,
          option: {
            計画PlbscfService: v計画PlbscfService,
            実態BSService: v実態BSService,
          },
        },
      ],
    };
  },
});
